<template>
  <div>
    <b-container v-show="!isIAPSuccess" class="py-5 custom-container">
      <b-row align-v="center" class="mt-5 mb-3">
        <b-col class="my-4 py-4">
          <h2 class="font-weight-bold">Confirm and pay</h2>
        </b-col>
      </b-row>
      <b-row align-h="between" class="px-3">
        <b-col cols="12" lg="8" md="8" sm="12" order-md="1" order="2">
          <b-card>
            <b-form @submit.prevent="confirmPayModal = true" class="px-5 py-4">
              <b-row>
                <b-col cols="12" class="mb-5">
                  <h3 class="mb-3 font-weight-bold">Your details</h3>
                  <label for="fullName">Full Name</label>
                  <b-form-input
                    id="fullName"
                    v-model="form.full_name"
                    type="text"
                    placeholder="Full Name"
                    required
                  ></b-form-input>
                </b-col>
                <b-col cols="12" class="mb-5">
                  <h3 class="mb-3 font-weight-bold">Payment method</h3>
                  <b-row class="px-3">
                    <b-col cols="12">
                      <label for="cardNumber">Card Number</label>
                      <div id="cardNumber" class="form-control"></div>
                      <div
                        id="cardNumberError"
                        class="invalid-feedback d-block"
                        role="alert"
                      ></div>
                    </b-col>
                    <b-col cols="12" md="6" class="pr-md-2">
                      <label for="cardExpiry">Expiry</label>
                      <div id="cardExpiry" class="form-control"></div>
                      <div
                        id="cardExpiryError"
                        class="invalid-feedback d-block"
                        role="alert"
                      ></div>
                    </b-col>
                    <b-col cols="12" md="6" class="pl-md-2">
                      <label for="cardCVC">CVC</label>
                      <div id="cardCvc" class="form-control"></div>
                      <div
                        id="cardCvcError"
                        class="invalid-feedback d-block"
                        role="alert"
                      ></div>
                    </b-col>
                    <b-col cols="12">
                      <b-form-text
                        variant="error"
                        id="stripeTokenError"
                      ></b-form-text>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="mb-5">
                  <h3 class="mb-3 font-weight-bold">Billing information</h3>
                  <b-row class="px-3">
                    <b-col cols="12">
                      <label for="address">Address</label>
                      <b-form-input
                        required
                        v-model="form.address"
                        id="address"
                        type="text"
                        placeholder="Address"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="pr-md-2">
                      <label for="city">City/Suburb</label>
                      <b-form-input
                        required
                        v-model="form.city"
                        id="city"
                        type="text"
                        placeholder="City/Suburb"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="pl-md-2">
                      <label for="postCode">Postcode</label>
                      <b-form-input
                        required
                        v-model="form.postcode"
                        id="postCode"
                        type="text"
                        placeholder="Postcode"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="pr-md-2">
                      <label for="state">State</label>
                      <b-form-input
                        required
                        v-model="form.state"
                        id="state"
                        type="text"
                        placeholder="State"
                      ></b-form-input>
                    </b-col>
                    <b-col cols="12" md="6" class="pl-md-2">
                      <label for="country">Country</label>
                      <b-form-select
                        required
                        id="country"
                        value-field="iso2"
                        text-field="name"
                        v-model="form.country"
                        disabled-field="loading"
                        :options="countries"
                      ></b-form-select>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" class="mb-5">
                  <b-row>
                    <b-col cols="12" md="6">
                      <b-button block type="submit" variant="primary">
                        Confirm and pay
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
        <b-col cols="12" lg="3" md="3" sm="12" order-md="2" order="1">
          <b-card>
            <b-card-title>Premium Package</b-card-title>
            <b-card-text v-if="isTradieUser">
              $1.99/month after 7 days free trial
            </b-card-text>
            <b-card-text v-else>
              $9.99/month after 7 days free trial
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-alert
      dismissible
      fade
      class="custom-alert"
      :show="dismissCountDown"
      :variant="alertType"
      @dismissed="clearAlert"
      @dismiss-count-down="dlCountDownChanged"
    >
      {{ alertMsg }}
    </b-alert>

    <b-modal
      centered
      v-model="confirmPayModal"
      id="confirmPayModal"
      :no-close-on-backdrop="loading"
    >
      <template #modal-header>
        <h3>Confirm Pay</h3>
        <b-button
          pill
          @click="confirmPayModal = false"
          size="sm"
          variant="white"
          class="px-0 h-25"
        >
          <b-icon icon="x"></b-icon>
        </b-button>
      </template>

      <template #default>
        <p>Are you sure you want to confirm your premium subscription?</p>
      </template>

      <template #modal-footer>
        <b-container fluid>
          <b-row class="justify-content-sm-end justify-content-center">
            <b-col cols="12" sm="5">
              <b-button
                block
                size="lg"
                variant="outline-secondary"
                class="px-4 mr-sm-1"
                :disabled="loading"
                @click="confirmPayModal = false"
              >
                No, cancel
              </b-button>
            </b-col>
            <b-col cols="12" sm="6">
              <b-button
                block
                size="lg"
                variant="primary"
                class="px-1 ml-sm-1"
                :disabled="loading"
                @click="submitSubscription"
              >
                Yes, confirm
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <transition name="fade">
      <subscription-success-page v-show="isIAPSuccess" />
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Form from '@/utils/form'
import SubscriptionSuccessPage from './SuccessPage'

export default {
  name: 'SubscribePage',

  components: {
    SubscriptionSuccessPage
  },

  data() {
    return {
      loading: false,
      stripe: null,
      elements: null,
      isIAPSuccess: false,
      confirmPayModal: false,
      form: new Form({
        full_name: '',
        card_number: '',
        card_expiry: '',
        card_cvc: '',
        address: '',
        city: '',
        postcode: '',
        state: '',
        country: 'AU',
        payment_method: null
      }),
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary'
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      countries: state => state.country.countries
    }),

    isTradieUser() {
      return this.user ? this.user.user_type === 'tradie' : false
    },

    stripeElements() {
      return this.$stripe.elements()
    }
  },

  methods: {
    ...mapActions({
      subscribeToPremium: 'subscription/subscribeToPremium',
      getCountries: 'country/getCountries'
    }),

    async createStripeCardToken(e) {
      this.loading = true
      const cardPmData = {
        type: 'card',
        card: this.form.card_number,
        billing_details: {
          address: {
            city: this.form.city,
            country: this.form.country,
            postal_code: this.form.postcode,
            state: this.form.state
          },
          email: this.user.email,
          name: this.form.full_name
        }
      }

      await this.stripe.createPaymentMethod(cardPmData).then(res => {
        if (res.error) {
          if (res.error.type !== 'validation_error') {
            const error = document.getElementById('stripeTokenError')
            error.textContent = res.error.message
          }

          this.loading = false
        } else {
          this.form.payment_method = res.paymentMethod.id
        }
      })
    },

    async submitSubscription() {
      this.loading = true
      this.form.$busy = true

      await this.createStripeCardToken().then(() => {
        this.subscribeToPremium({
          payment_method: this.form.payment_method
        })
          .then(() => {
            this.isIAPSuccess = true

            this.form.$reset()
          })
          .catch(error => {
            this.form.$handleError(error)

            setTimeout(e => {
              this.clearAlert()
            }, 5000)

            this.alertType = 'danger'
            this.alertMsg =
              'Something went wrong while upgrading your account to premium!'
            this.dismissCountDown = 5
          })
          .finally(() => {
            this.loading = false
            this.form.$busy = false
            this.confirmPayModal = false
          })
      })
    },

    dlCountDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    }
  },

  async mounted() {
    await this.getCountries()

    this.stripe = window.Stripe(this.$env.stripePublishableKey)
    this.elements = this.stripe.elements()

    const style = {
      base: {
        fontFamily: 'Lato, Helvetica, Arial, sans-serif',
        fontSize: '16px',
        fontWeight: '400',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          fontSize: '16px',
          fontWeight: '400',
          fontFamily: 'Lato, Helvetica, Arial, sans-serif',
          color: '#b2b2b2'
        }
      }
    }

    this.form.card_number = this.elements.create('cardNumber', {
      placeholder: 'Card Number',
      style: style
    })
    this.form.card_number.mount('#cardNumber')
    this.form.card_number.on('change', e => {
      const error = document.getElementById('cardNumberError')
      error.textContent = e.error ? e.error.message : ''
    })

    this.form.card_expiry = this.elements.create('cardExpiry', {
      placeholder: 'Card Expiry',
      style: style
    })
    this.form.card_expiry.mount('#cardExpiry')
    this.form.card_expiry.on('change', e => {
      const error = document.getElementById('cardExpiryError')
      error.textContent = e.error ? e.error.message : ''
    })

    this.form.card_cvc = this.elements.create('cardCvc', {
      placeholder: 'Card CVC',
      style: style
    })
    this.form.card_cvc.mount('#cardCvc')
    this.form.card_cvc.on('change', e => {
      const error = document.getElementById('cardCvcError')
      error.textContent = e.error ? e.error.message : ''
    })
  },

  beforeDestroy() {
    this.form.$clearErrors()
    this.form.$reset()
  }
}
</script>

<style lang="scss" scoped>
.StripeElement--focus {
  border: 2px solid #2c66d5;
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}

#card-number.form-control,
#card-cvc.form-control,
#card-exp.form-control {
  display: inline-block;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;

  & .__PrivateStripeElement {
    padding: 8px 0px !important;
  }
}

.form-control.StripeElement {
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
